import type { PropsWithChildren } from 'react';

export const ListItem = ({ children }: PropsWithChildren) => (
  <li className="ml-8 flex items-center gap-7 text-Gray-800 typo-body4">
    <div className="mb-auto h-fit before:content-['·']" />
    {children}
  </li>
);
